import * as angular from 'angular';

"use strict";

angular.module('PermissionModule', [])

export default 'PermissionModule';
